import { PageHero } from "../components/common/PageHero";
import { RoomCard } from "../components/common/RoomCard";
import { FinalCta } from "../components/common/FinalCta";
import { Reveal } from "../components/motion/Reveal";
import { useC } from "../context/SiteData";

const Odalar = () => {
  const c = useC();

  return (
    <>
      <PageHero
        title={c.ph_odalar_title}
        subtitle={c.ph_odalar_subtitle}
        desc={c.ph_odalar_desc}
      />
      <section data-testid="odalar-list" className="section-y">
        <div className="container-x">
          <div className="mx-auto grid max-w-4xl gap-6 sm:grid-cols-2">
            {c.rooms.map((room, i) => (
              <RoomCard key={room.slug} room={room} delay={i * 0.1} />
            ))}
          </div>
          <Reveal delay={0.2}>
            <div className="mt-16 grid gap-px border border-line bg-line sm:grid-cols-3">
              {c.odalar_badges.map((b) => (
                <div key={b.label} className="group bg-cream-100 p-7 transition-colors duration-300 hover:bg-ink-900">
                  <p className="text-xs font-bold uppercase tracking-[0.2em] text-ink-400 transition-colors duration-300 group-hover:text-cream-50/50">{b.label}</p>
                  <p className="mt-2 text-lg font-bold tracking-tight text-ink-900 transition-colors duration-300 group-hover:text-cream-50">{b.text}</p>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </section>
      <FinalCta />
    </>
  );
};

export default Odalar;
